import DragHorizontal16 from '@carbon/icons-react/es/drag--horizontal/16';
import Filter16 from '@carbon/icons-react/es/filter/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Widget as WidgeT } from 'api/dashboard';
import { Widget } from 'components/organisms/csat/overview/widgets/widget';
import { FilterGroupType } from 'components/pages/types';
import { SingleLineEllipsis } from 'components/styles';
import { FilterAsText } from '../filter-as-text';
import { useWidgetFilter } from '../use-widget-filter';
import { TitleWrapper } from './styles';

const Title = styled.div`
  ${SingleLineEllipsis};
  flex: 1;
`;

const StyledWidget = styled(Widget)`
  height: var(--spacing-09);
  cursor: grabbing;
`;

export const ChartDndOverLay: FC<{ widget: WidgeT }> = ({ widget }) => {
  const filter = useWidgetFilter({
    widget,
    defaultGroup: FilterGroupType.Project,
  });

  return (
    <StyledWidget
      title={
        <TitleWrapper>
          <span>
            <DragHorizontal16 />
          </span>

          {filter.groupCriteria.length === 0 ? null : (
            <Tooltip
              overlayStyle={{ maxWidth: 'unset' }}
              title={<FilterAsText filter={filter} />}
            >
              <Filter16 />
            </Tooltip>
          )}
          <Title>{widget.widgetName}</Title>
        </TitleWrapper>
      }
    />
  );
};
